export default __webpack_public_path__ + "static/media/delete.37ae6217.svg";